import clientModel from '../../../model/clientmodel';

const handleError=()=>{

}

export default {
    fetchTo({commit},[fn]){
        let url='http://tulu-app.artron.net/wap/operate/articleList';
         return clientModel.getPost(url).
        then(
            data=>{
                commit('fillToArtistNumb',data);
                //设置顶级mate信息
                commit('setArtistNumbMeta', data, {root: true})
                if(fn!=undefined) fn()
            }
        ).catch(err=>{
            console.log(err);
            handleError(err);
        })
    }
}